module.exports = __webpack_public_path__ + "static/img/1.41c0883.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/HeatTreatment/1.png
// module id = 5kPn
// module chunks = 13